import { useContext, useState } from 'react'
import {
  Drawer,
  Button,
  ButtonToolbar,
  Modal,
  Form,
  FormControl,
  HelpBlock,
  FormGroup,
  ControlLabel,
  InputNumber,
  Alert,
  Grid,
  Row,
  Col,
} from 'rsuite'
import { WrapperContext } from '../../../interfaces/contexts'
import * as FileSaver from 'file-saver'
import XLSX from 'tempa-xlsx'
import { excelSheetFromDataSet, strToArrBuffer } from '../../../utils/excelUtil'

var numberF = new Intl.NumberFormat('vi-VN', {
  style: 'currency',
  currency: 'VND',
})

const ExportCSV = (list) => {
  const fileType =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
  const style = {
    font: { bold: true, color: { rgb: 'FFFFFFFF' } },
    fill: { fgColor: { rgb: 'FF133F67' } },
    alignment: { horizontal: 'center' },
  }
  let total = 0
  let listData = list.map((item) => {
    total += (item.price * item.quantity * (100 - item.discount)) / 100
    return [
      { value: item.isbn },
      { value: item.level },
      { value: item.class },
      { value: item.category },
      { value: item.title },
      { value: parseInt(item.quantity) },
      { value: item.price, style: { numFmt: '0,000 ₫' } },
      { value: item.price * item.quantity, style: { numFmt: '0,000 ₫' } },
      { value: item.discount / 100, style: { numFmt: '0%' } },
    ]
  })
  listData.push([
    { value: '' },
    { value: '' },
    { value: '' },
    { value: '' },
    { value: '' },
    { value: '' },
    { value: 'Tổng tiền', style: { font: { bold: true } } },
    { value: total, style: { numFmt: '0,000 ₫' } },
    { value: '' },
  ])
  let dataSet = [
    {
      columns: [
        { title: 'Mã ISBN', width: { wpx: 100 }, style },
        { title: 'Cấp', width: { wpx: 90 }, style },
        { title: 'Lớp', width: { wpx: 90 }, style },
        { title: 'Loại sách', width: { wpx: 90 }, style },
        { title: 'Tên tựa sách', width: { wpx: 300 }, style },
        { title: 'Số lượng', width: { wpx: 70 }, style },
        { title: 'Giá bán', width: { wpx: 90 }, style },
        { title: 'Thành tiền', width: { wpx: 90 }, style },
        { title: 'Chiết khấu', width: { wpx: 90 }, style },
      ],
      data: listData,
    },
  ]

  const ws = excelSheetFromDataSet(dataSet)

  const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
  const wbout = XLSX.write(wb, {
    bookType: 'xlsx',
    bookSST: true,
    type: 'binary',
  })
  return new Blob([strToArrBuffer(wbout)], { type: fileType })
}

export const CartDrawer = () => {
  const { initDrawer, carts } = useContext(WrapperContext)
  const [showForm, setShowForm] = useState(false)

  const onClose = () => {
    initDrawer.setState(null)
  }

  const rowClick = (item) => {
    const list = carts.state
    list.splice(
      list.findIndex((m) => m.isbn == item.isbn),
      1
    )
    carts.setState([...list])
  }

  const onExport = () => {
    if (!carts.state) return
    const fileExtension = '.xlsx'
    const data = ExportCSV(carts.state)
    FileSaver.saveAs(data, 'e-catalog' + fileExtension)
  }

  const onShowForm = () => {
    setShowForm(true)
  }

  const onChangeQuantity = (item, value) => {
    var prod = carts.state.find((m) => m.isbn == item.isbn)
    prod.quantity = value
    carts.setState([...carts.state])
  }

  const onSubmitForm = () => {
    const file = ExportCSV(carts.state)
    var data = new FormData(document.getElementById('form-send-mail'))
    data.append('fileAttached', file, 'e-catalog.xlsx')

    fetch('https://api.dtpmira.com/mas/external/catalog/sendmail', {
      method: 'POST',
      body: data,
    })
      .then((resp) => resp.json())
      .then((resp) => {
        if (resp.success) {
          Alert.success(
            'Cảm ơn thầy/cô đã đặt hàng. Bộ phận CSKH sẽ liên hệ đến thầy/cô để xác nhận thông tin.',
            10000
          )
          setShowForm(false)
        } else {
          Alert.error(resp.message)
        }
      })
      .catch((err) => {
        Alert.error('Có lỗi xảy ra')
        console.log('err', err)
      })
  }

  return (
    <Drawer
      className="cart"
      size="lg"
      placement="right"
      onHide={onClose}
      show={initDrawer?.state?.isShow}
    >
      <Drawer.Header>
        <Drawer.Title>Giỏ hàng</Drawer.Title>
      </Drawer.Header>
      <Drawer.Body>
        <div className="content">
          <div className="content-body">
            <table>
              <thead>
                <tr>
                  <th>Mã ISBN</th>
                  <th>Cấp</th>
                  <th>Lớp</th>
                  <th>Loại sách</th>
                  <th>Tên tựa sách</th>
                  <th>Số lượng</th>
                  <th>Giá bán</th>
                  <th>Thành tiền</th>
                  <th>Chiết khấu</th>
                  <th>#</th>
                </tr>
              </thead>
              <tbody>
                {carts?.state?.map((item) => (
                  <tr key={item.isbn}>
                    <td>{item.isbn}</td>
                    <td>{item.level}</td>
                    <td>{item.class}</td>
                    <td>{item.category}</td>
                    <td>{item.title}</td>
                    <td align="center">
                      <InputNumber
                        min={1}
                        value={item.quantity}
                        onChange={(value) => {
                          onChangeQuantity(item, value)
                        }}
                      />
                    </td>
                    <td>{numberF.format(item.price)}</td>
                    <td>{numberF.format(item.price * item.quantity)}</td>
                    <td align="center">{`${item.discount}%`}</td>
                    <td align="center">
                      <a
                        onClick={() => {
                          rowClick(item)
                        }}
                      >
                        <img
                          width="30"
                          height="30"
                          src="./images/icons/ic-minus.png"
                        />
                      </a>
                    </td>
                  </tr>
                ))}
                {carts?.state == null || carts?.state.length == 0 ? (
                  <tr>
                    <td colSpan="12" align="center">
                      Không có dữ liệu
                    </td>
                  </tr>
                ) : null}
              </tbody>
              {carts?.state?.length > 0 ? (
                <tfoot>
                  <tr>
                    <td colSpan="7" align="right">
                      <b>Tổng tiền</b>
                    </td>
                    <td>
                      {numberF.format(
                        carts.state.reduce(
                          (a, b) =>
                            a +
                            (b.price * b.quantity * (100 - b.discount)) / 100,
                          0
                        )
                      )}
                    </td>
                    <td></td>
                  </tr>
                </tfoot>
              ) : null}
            </table>
          </div>
          <div className="content-footer">
            <ButtonToolbar>
              <Button
                onClick={onExport}
                disabled={!(carts?.state?.length > 0)}
                appearance="primary"
              >
                Export
              </Button>
              <Button
                onClick={onShowForm}
                disabled={!(carts?.state?.length > 0)}
                color="green"
              >
                Send
              </Button>
            </ButtonToolbar>
          </div>
        </div>
        <Modal
          backdrop={'static'}
          className={'m-send-form'}
          size="xs"
          show={showForm}
          onHide={() => setShowForm(false)}
        >
          <Modal.Header></Modal.Header>
          <Modal.Body>
            <Form id="form-send-mail">
              <Grid fluid>
                <Row>
                  <Col className="__col" xs={24} sm={12}>
                    <FormGroup>
                      <ControlLabel>Thông tin chung trường</ControlLabel>
                      <FormControl name="province" placeholder="Tỉnh" />
                    </FormGroup>
                    <FormGroup>
                      <FormControl name="office" placeholder="Phòng" />
                    </FormGroup>
                    <FormGroup>
                      <FormControl name="address" placeholder="Địa chỉ" />
                    </FormGroup>
                    <FormGroup>
                      <FormControl name="school" placeholder="Trường học" />
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Thông tin người gửi</ControlLabel>
                      <FormControl
                        name="fullName"
                        placeholder="Họ và tên người gửi"
                      />
                    </FormGroup>
                    <FormGroup>
                      <FormControl
                        name="phone"
                        placeholder="Điện thoại người gửi"
                      />
                    </FormGroup>
                    <FormGroup className="mb-0">
                      <FormControl
                        name="fromMail"
                        placeholder="Email người gửi"
                        type="email"
                      />
                    </FormGroup>
                  </Col>
                  <Col className="__col" xs={24} sm={12}>
                    <FormGroup>
                      <ControlLabel>Thông tin người nhận</ControlLabel>
                      <FormControl
                        name="toEmail"
                        type="email"
                        placeholder="Email người nhận"
                        value="cs.esvn@dtp-education.com"
                        readOnly={true}
                      />
                    </FormGroup>
                    <FormGroup>
                      <FormControl
                        name="title"
                        placeholder="Tiêu đề"
                        value="đơn hàng Thư viện"
                        readOnly={true}
                      />
                    </FormGroup>
                    <FormGroup className="mb-0">
                      <FormControl
                        name="contentMessage"
                        rows={5}
                        componentClass="textarea"
                        placeholder="Nội dung cần gửi"
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </Grid>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button appearance="default" onClick={() => setShowForm(false)}>
              Cancel
            </Button>
            <Button appearance="primary" onClick={onSubmitForm}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </Drawer.Body>
    </Drawer>
  )
}
